import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { SplashComponent } from './pages/splash/splash.component';
import { LoginComponent } from './pages/login/login.component';
import { DashComponent } from './pages/dash/dash.component';
import { AuthGuard } from './providers/auth';
import { HomeComponent } from './pages/dash/home/home.component';
import { UsersComponent } from './pages/dash/users/users.component';
import { UserComponent } from './pages/dash/user/user.component';
import { CarpetaComponent } from './pages/dash/carpeta/carpeta.component';
import { FinishSignUpComponent } from './pages/finish-sign-up/finish-sign-up.component';
import { ProyectoComponent } from './pages/dash/proyecto/proyecto.component';
import { RedirectPqrComponent } from './pages/redirect-pqr/redirect-pqr.component';

export const router: Routes = [
    { path: '', component: SplashComponent, pathMatch: 'full' },
    { path: 'finishSignUp/:uid', component: SplashComponent },
    { path: 'registro/:uid', component: FinishSignUpComponent },
    { path: 'login', component: LoginComponent },
    {
		path: 'dashboard',
		component: DashComponent,
        canActivate: [AuthGuard],
        children: [
			{
				path: '',
				canActivateChild: [AuthGuard],
				component: HomeComponent,
			},
			{
				path: 'usuarios',
				canActivateChild: [AuthGuard],
				component: UsersComponent,
			},
			{
				path: 'usuarios/:id',
				canActivateChild: [AuthGuard],
				component: UserComponent,
			},
			{
				path: 'usuarios/:idu/:idp/:carpeta',
				canActivateChild: [AuthGuard],
				component: CarpetaComponent,
			},
			{
				path: ':idu/proyecto/:idp',
				canActivateChild: [AuthGuard],
				component: ProyectoComponent,
			},
		]
    },
    { path: ':nserie', component: RedirectPqrComponent/* , canActivate: [AuthGuard] */ },
    { path: '**', component: NotFoundComponent }
];

export const routes: ModuleWithProviders = RouterModule.forRoot(router);


// WEBPACK FOOTER //
// ./src/app/app.routes.ts